import { Injectable, inject, signal } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable } from 'rxjs';
import { UserRole } from '../driver-pay/persistence/implementation/users/User';

export interface AuthError {
  key: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  canActivate(): Observable<boolean | UrlTree> {
    return this.oidcSecurityService.checkAuth().pipe(
      map(({ isAuthenticated }) => {
        if (isAuthenticated) {
          return true;
        }
        this.oidcSecurityService.authorize();
        return false;
      })
    );
  }
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  isLoggedIn;

  constructor() {
    this.isLoggedIn = this.oidcSecurityService.authenticated;
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe((result) => console.log(result));
  }

  readonly roles = signal<Set<UserRole>>(new Set());
  readonly error = signal<AuthError | null>(null);
  setRoles(roles: Iterable<UserRole>) {
    this.roles.set(new Set(roles));
  }

  canEdit(): boolean {
    return [...this.roles()].some((r) => r === 'ADMINISTRATOR' || r === 'MANAGER' || r === 'SPECIALIST');
  }

  setError(err: any) {
    this.error.set({
      key: `API Error ${err?.status ?? ''}`.trim(),
      value: err?.error?.error || err?.message || 'Unknown error',
    });
  }

  clearError() {
    this.error.set(null);
  }
}
